import React, { useContext, useState, useEffect } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Button from "@material-ui/core/Button";
import "./scheduleSearchResult.css";
import { StoreContext } from "../../../../store/Provider";
import ModalContainer from "../../../common/ModalBox/ModalContainer";
import MainLayout from "../../../common/Layout/MainLayout";
import { basename } from '../../../../config';

function ScheduleSearchResult() {
  const context = useContext(StoreContext);
  const [comLogo, setComLogo] = useState([]);
  const [compName, setCompName] = useState([]);
  const [lines, setLines] = useState([]);
  const [dataQuote, setDataQuote] = useState({
    logo: "",
    compName: "",
    data: []
  });

  useEffect(() => {
    createDataSet();
  }, []);

  const createDataSet = () => {
    let logo = [];
    let data = [];
    let companyName = [];
    context.searchResult.forEach((element) => {
      logo.push(element.line_logo);
      companyName.push(element.line_name);
      let tempData = [];
      element.line.forEach((item) => {
        tempData.push(item);
      });
      data.push(tempData);
    });
    setComLogo(logo);
    setCompName(companyName);
    setLines(data);
  };

  const requestQuote = (data, index) => {
    context.setModalType("requestQuote");
    context.handleModalOpen();
    setDataQuote({
      logo: comLogo[index],
      compName: compName[index],
      data
    });
  };

  return (
    <div className="scheduleSearchResult">
      <ModalContainer type="requestQuote" data={dataQuote} />
      {/* <div className="scheduleSearchResultHeader">
                <span onClick={history.goBack} className="pointer">Go Back</span>
                <span onClick={history.goBack} className="pointer">
                    <img src="/Assets/Images/backArrow.svg" alt="backArrow" /></span>
            </div> */}
      <div className="scheduleSearchResultBody">
        <div className="scheduleSearchResultBodyInner">
          {context.searchResult.length === 0 ? (
            <div>No Schedule found.</div>
          ) : (
            lines.map((element, index) => {
              return element.map((item, i) => {
                let date = new Date(0);
                date.setUTCSeconds(item.cutOff);
                const cutoffdate = moment(date).format("MM/DD/YYYY");
                return (
                  <div key={i} className="scheduleSearchcardbody">
                    <div className="scheduleSearchcardbodyCommon mb-2 pb-2">
                      <div className="scheduleSearchcardbodyInner">
                        <div className="scheduleSearchcardInner compdetails ps-0">
                          <img src={comLogo[index]} alt="company logo" />
                          <span>{compName[index]}</span>
                        </div>
                        <div className="scheduleSearchcardInner commondetails">
                          <span>TRANSIT DAYS</span>
                          <p>{item.transitTime} Days</p>
                        </div>
                        <div className="scheduleSearchcardInner commondetails">
                          <span>ETA</span>
                          <p>{cutoffdate}</p>
                        </div>
                        <div className="scheduleSearchcardInner requestQuote">
                          <Button
                            variant="contained"
                            onClick={() => {
                              requestQuote(item, index);
                            }}
                          >
                            Request Quote
                          </Button>
                        </div>
                      </div>
                    </div>
                    <div className="scheduleSearchcardbodyItterarte">
                      {item.transShipments.map((transShipments, index) => {
                        let etdDate = new Date(0);
                        etdDate.setUTCSeconds(transShipments.departure.date);
                        const etd = moment(etdDate).format("MM/DD/YYYY");
                        let etaDate = new Date(0);
                        etaDate.setUTCSeconds(transShipments.arrival.date);
                        const eta = moment(etaDate).format("MM/DD/YYYY");
                        console.log(transShipments);
                        return (
                          <div
                            key={index}
                            className="scheduleSearchcardbodyInner"
                          >
                            <div className="scheduleSearchcardInner commondetails ps-0">
                              <span>Vessel</span>
                              <p title={transShipments.vesselName}>
                                {!transShipments.vesselName &&
                                  transShipments.vesselName === null
                                  ? "N/A"
                                  : transShipments.vesselName}
                              </p>
                            </div>
                            <div className="scheduleSearchcardInner commondetails">
                              <span>Service</span>
                              <p title={transShipments.service}>
                                {!transShipments.service &&
                                  transShipments.service === null
                                  ? "N/A"
                                  : transShipments.service}
                              </p>
                            </div>
                            <div className="scheduleSearchcardInner commondetails">
                              <span>ETD</span>
                              <p>{!etd && etd !== null ? "N/A" : etd}</p>
                            </div>
                            <div className="scheduleSearchcardInner commondetails">
                              <span>ETA</span>
                              <p>{!eta && eta !== null ? "N/A" : eta}</p>
                            </div>
                            <div className="scheduleSearchcardInner milecol">
                              <div className="searchshptimelineBody">
                                <span>ORIGIN</span>
                                <div className="searchshptimelinecontainer">
                                  <span>
                                    <img
                                      src={`/${basename}/Assets/Images/PlaceDot.svg`}
                                      alt="placeDot"
                                    />
                                  </span>
                                  <span>
                                    <img
                                      src={`/${basename}/Assets/Images/PlaceDot.svg`}
                                      alt="placeDot"
                                    />
                                  </span>
                                  <img
                                    className="dottedline"
                                    src={`/${basename}/Assets/Images/Line.svg`}
                                    alt="line"
                                  />
                                </div>
                                <span>DESTINATION</span>
                              </div>
                              <p>
                                <span title={transShipments.departure.portName}>
                                  {transShipments.departure.portName}
                                </span>
                                <span title={transShipments.arrival.portName}>
                                  {transShipments.arrival.portName}
                                </span>
                              </p>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              });
            })
          )}
        </div>
      </div>
    </div>
  );
}

export default ScheduleSearchResult;
